export default {
  methods: {
    formatScore(value) {
      const num = Number(value)
      return num % 1 === 0 ? num : num.toFixed(2)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Leaders/Listing/mixins/formatScore.js